import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  author: string;
  publishedAt: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categorySlug,
  author,
  publishedAt,
  readTime,
  imageUrl,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200/50 transition-all duration-300 flex flex-col">
      <Link to={`/article/${slug}`} className="block overflow-hidden cursor-pointer">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${categorySlug}`}
              className="inline-block px-3 py-1 text-xs bg-primary-500/90 text-background-50 rounded-full cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              {category}
            </Link>
          </div>
        </div>
      </Link>

      <div className="flex flex-col flex-1 p-4 md:p-5">
        <Link to={`/article/${slug}`} className="cursor-pointer">
          <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
            {title}
          </h3>
        </Link>

        <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2 flex-1">
          {excerpt}
        </p>

        <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
          <span className="whitespace-nowrap">{author}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span className="whitespace-nowrap">{publishedAt}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span className="whitespace-nowrap">{readTime}</span>
        </div>

        <div className="flex flex-wrap gap-1.5">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-md whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}